"use strict";
document.querySelectorAll('.blocks-wrapper').forEach(function (container) {
    var scrollIndicator = container.querySelector('.swipe-indicator');
    if (scrollIndicator) {
        scrollIndicator.classList.remove("hidden-xl-up");
        var hasHorizontalScroll = container.scrollWidth > container.clientWidth;
        if (!hasHorizontalScroll) {
            scrollIndicator.classList.add("d-none");
        }
        container.addEventListener('scroll', function () {
            scrollIndicator.classList.add("d-none");
        });
    }
    scrollIndicator === null || scrollIndicator === void 0 ? void 0 : scrollIndicator.addEventListener("click", function () {
        container.scrollTo({
            left: 200,
            behavior: 'smooth'
        });
    });
});
